<template>
  <footer class="main-footer" :class="{'skeleton-load': isLoading }">
    <div class="container" v-if="!isLoading">
      <div class="footer-header">
        <img class="footer-logo" :src="feed.logo" alt="Slothtech - Eventos" />
        <ul class="social-feed">
          <li>
            <a :href="feed.facebook" target="_blank">
              <i class="fa fa-facebook"></i>
            </a>
          </li>
          <li>
            <a :href="feed.instagram" target="_blank">
              <i class="fa fa-instagram"></i>
            </a>
          </li>
          <li>
            <a :href="feed.github" target="_blank">
              <i class="fa fa-github"></i>
            </a>
          </li>
          <li>
            <a :href="feed.youtube" target="_blank">
              <i class="fa fa-youtube"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
import firebase from "firebase/app";

export default {
  data() {
    return {
      feed: {},
      isLoading: true
    };
  },
  created() {
    (async () => {
      try {
        this.feed = await firebase
          .database()
          .ref("social_media/")
          .once("value")
          .then(snapshot => snapshot.val());
        this.isLoading = false;
      } catch (error) {
        console.log(error);
      }
    })();
  }
};
</script>